import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { SidebarLabelConstant } from '../../constants/label-constants';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { StorageService } from '../../services/storage/storage.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditUserDialogComponent } from '../../pages/user-management/add-edit-user/add-edit-user.component';
import { EventService } from '../../services/event.service';
import { StateService } from '../../services/common/claim-year.service';
import { UserService } from '../../services/user-service/user.service';
import { ChangePasswordComponent } from '../../pages/change-password/change-password.component';
import { LoginDevicesListComponent } from '../../pages/login-devices-list/login-devices-list.component';
import { SharedService } from '../../services/shared-service/shared.service';

interface MenuItem {
  showInMenu:boolean
  id: number;
  name: string;
  icon: string;
  url: string;
  isParent: boolean;
  parentId: number;
  isForm: boolean;
  formId: number;
  subMenus?: MenuItem[];
  subItems?: MenuItem[];
  isOpen?: boolean;
  isRawData: boolean;
  isNotePending:boolean;
}

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss'],
})

export class MenuSidebarComponent implements OnInit {
  companyId: number | null = null;
  yearId: number | null = null;
  userId!: any;
  labelConstant: any;
  isOpen = false;
  menuItems: MenuItem[] = [];
  labelConstants: any;
  userName!: string;
  userImage!: string;
  roleName!: string;
  activeMenuItem: string = '';
  isNotePending:boolean=false;

  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly commonService: CommonService,
    private readonly spinner: NgxSpinnerService,
    private readonly toster: ToastrService,
    private readonly apiUrl: ApiUrlHelper,
    private readonly dialog: MatDialog,
    private readonly _eventService: EventService,
    private readonly sharedDataService: StateService,
    private readonly toastr: ToastrService,
    private readonly userService: UserService,
    private readonly sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.userService.userName$.subscribe((newUserName) => {
      this.userName = newUserName;
    });
    this.sharedDataService.companyId$.subscribe((companyId: number | null) => {
      this.companyId = companyId;
    });
    this.sharedDataService.yearId$.subscribe((yearId: number | null) => {
      this.yearId = yearId;
    });
    this.sharedService.getIsNotePending().subscribe((data) => {
      this.isNotePending = data;
    });
    let decryptUserId = this.storageService.getValue('userId');
    this.userId = this.commonService.Decrypt(decryptUserId);
    this.roleName = this.storageService.getValue('userRole');
    this.labelConstant = SidebarLabelConstant;
    this.userImage = this.storageService.getValue('userImage');
    this.commonService.getUserImage().subscribe(image => {
      if (image == '') {
        this.userImage = this.storageService.getValue('userImage') ? this.storageService.getValue('userImage') : '';
      }
      else {
        this.userImage =  image || '';
        localStorage.setItem('userImage', this.userImage);
      }
    });
    this.FetchMenuList();
    this._eventService.subscribe('sideBarData', (data) => {
      this.FetchMenuList();
    });
  }

  openSubmenusBasedOnUrl() {
    const url = this.router.url;
    this.menuItems.forEach(menuItem => {
      if (url.startsWith(menuItem.url)) {
        menuItem.isOpen = true;
        this.openParentMenu(menuItem);
      }
    });
  }

  openParentMenu(menuItem: MenuItem) {
    menuItem.subMenus?.forEach((subMenu: MenuItem) => {
      if (this.router.url.startsWith(menuItem.url + subMenu.url)) {
        subMenu.isOpen = true;
        this.openParentMenu(subMenu);
      }
    });
  }

  logOut(action: any) {
    this.activeMenuItem = 'Logout';
    this.isOpen = false;
    let apiUrl = '';
    if (localStorage.getItem('authToken') != null) {
      let loginTokenIdEncrypted = localStorage.getItem('loginTokenId') ? localStorage.getItem('loginTokenId') : '' ;
      var loginTokenId = loginTokenIdEncrypted == '' ? 0 : Number.parseInt(this.commonService.Decrypt(loginTokenIdEncrypted ?? ''))
      apiUrl = this.apiUrl.apiUrl.Login.logout.replace("{Id}",loginTokenId.toString());
    }
    else {
      this.router.navigate(['/login']);
      localStorage.clear();
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: { action },
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.activeMenuItem ='';
      if (result) {
        this.spinner.show();
        this.commonService.doPost(apiUrl, this.userId).pipe().subscribe({
          next: (response) => {
            if (response.success) {
              this.router.navigate(['/login']);
              this.sharedDataService.setCompanyId('');
              this.sharedDataService.setYearId('');
              this.spinner.hide();
            } else {
              this.toster.error(response.message);
              this.spinner.hide();
            }
          },
          error: (err) => {
            this.spinner.hide();
          },

        });
        localStorage.clear();
      }
    });
  }

  isDropdownOpen = false;
  toggleDropdown(menuItem: string = '') {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.isOpen = !this.isOpen;
    if (menuItem) {
      this.activeMenuItem = menuItem;
      this.isOpen = false;
    }
  }

  FetchMenuList() {
    let api = this.apiUrl.apiUrl.MenuList.GetMenuList;
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.spinner.hide();
          this.menuItems = this.parseMenuItems(response.data);
          this.isNotePending = this.menuItems[0].isNotePending;
          this.openSubmenusBasedOnUrl();
        } else {
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
      },
    });
  }

  parseMenuItems(response: any[]): MenuItem[] {
    if (!response || response.length == 0) {
      return [];
    }
    return response.map(item => {
      return {
        showInMenu:item.showInMenu,
        id: item.parentMenuId,
        name: item.parentMenuName,
        icon: item.icon,
        url: item.url,
        isParent: item.items !== null,
        parentId: 0,
        isForm: false,
        formId: 0,
        subMenus: item.items ? JSON.parse(item.items) : [],
        isOpen: false,
        isRawData: item.isRawData,
        ValidatePageAccess: item.validatePageAccess,
        isNotePending :item.isNotePending
      };
    });
  }

  parseMenuItemsChild(response: any[]): any[] {
    if (!response || response.length == 0) {
      return [];
    }
    return response.map(item => {
      return {
        showInMenu:item.showInMenu,
        id: item.parentMenuId,
        name: item.parentMenuName,
        icon: item.icon,
        url: item.url,
        isParent: item.items !== null,
        parentId: 0,
        isForm: false,
        formId: 0,
        subMenus: item.items ? this.parseMenuItemsChild(JSON.parse(item.items)) : [],
        isOpen: false,
        ValidatePageAccess: item.validatePageAcess
      };
    });
  }

  toggleSubMenu(menuItem: any, parentMenuItem: any, event: Event) {
    let decryptRoleId = this.storageService.getValue('roleId');
    let roleId = this.commonService.Decrypt(decryptRoleId);
    // if (menuItem.ValidatePageAccess > 0) {
    //   if (menuItem.ValidatePageAccess == 1 &&
    //     ((!this.companyId && (this.yearId == null || isNaN(Number(this.yearId)))) ||
    //       (this.companyId && (this.yearId == null || isNaN(Number(this.yearId)))) ||
    //       (!this.companyId && this.yearId))) {
    //     if (Number(roleId) == 1 && !this.companyId) {
    //       this.toastr.error('Select company and claim year.');
    //     } else {
    //       this.toastr.error('Select claim year.');
    //     }
    //     this.sharedDataService.setMenuRowData(true);
    //     return;
    //   } else if (menuItem.ValidatePageAccess == 2 && !this.companyId) {
    //     this.toastr.error('Select company.');
    //     this.sharedDataService.setMenuRowData(true);
    //     return;
    //   }
    // }
    this.sharedDataService.setMenuRowData(false);
    localStorage.removeItem('menuRowData');
    this.activeMenuItem = '';
    event.preventDefault();

    if (parentMenuItem) {
      parentMenuItem.subMenus.forEach((subMenu: any) => {
        if (subMenu !== menuItem) {
          subMenu.isOpen = false;
        }
      });
    } else {
      this.menuItems.forEach((item: any) => {
        if (item !== menuItem) {
          item.isOpen = false;
        }
      });
    }
    menuItem.isOpen = !menuItem.isOpen;
  }

  closeAllSubMenus(menuItem: MenuItem) {
    menuItem.subMenus?.forEach((subMenu: MenuItem) => {
      subMenu.isOpen = false;
      this.closeAllSubMenus(subMenu);
    });
  }

  private modalService = inject(NgbModal);

  addEditViewUser() {
    this.activeMenuItem = 'My Account';
    this.isOpen = false;
    const dialogRef = this.modalService.open(AddEditUserDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    });
    dialogRef.componentInstance.IsEdit = false;
    dialogRef.componentInstance.id = this.userId;
    dialogRef.componentInstance.IsProfile = true;
    dialogRef.result.then((res: string) => {
        this.activeMenuItem = "";
    });
  }

  handleImageError() {
    this.userImage = '../../../assets/img/default-user-profile.svg';
  }

  changePassword() {
    this.activeMenuItem = 'Change Password';
    this.isOpen = false;
    const modalRef = this.modalService.open(ChangePasswordComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modalRef.result.then((res: string) => {
      this.activeMenuItem = "";
  });
  }

  loginDevicesList() {
    this.activeMenuItem = 'Login Devices';
    this.isOpen = false;
    const modalRef = this.modalService.open(LoginDevicesListComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modalRef.result.then((res: string) => {
      if (res == 'cancel') {
        this.activeMenuItem = "";
      }
    });
  }

  toggleChildMenu(menuItem: any, event: Event) {
    let decryptRoleId = this.storageService.getValue('roleId');
    let roleId = this.commonService.Decrypt(decryptRoleId);
    if (menuItem.ValidatePageAccess > 0) {
      if (menuItem.ValidatePageAccess == 1 &&
        ((!this.companyId && (this.yearId == null || isNaN(Number(this.yearId)))) ||
          (this.companyId && (this.yearId == null || isNaN(Number(this.yearId)))) ||
          (!this.companyId && this.yearId))) {
        if (Number(roleId) == 1 && !this.companyId) {
          this.toastr.error('Select company and claim year.');
        } else {
          this.toastr.error('Select claim year.');
        }
        this.sharedDataService.setMenuRowData(true);
        return;
      } else if (menuItem.ValidatePageAccess == 2 && !this.companyId) {
        this.toastr.error('Select company.');
        this.sharedDataService.setMenuRowData(true);
        return;
      }
    }
    this.sharedDataService.setMenuRowData(false);
    localStorage.removeItem('menuRowData');
    this.activeMenuItem = '';
    event.preventDefault();
  }
  havingSubMenu(Item:any){
    return Item.subMenus.filter((x:any)=> x.showInMenu == true).length >0
  }
}
